module.exports = __webpack_public_path__ + "img/img2_tab.08fecd4a.jpg";